import React, {ReactNode} from 'react'
import Highlighter from '../Highlight'
import { Select } from 'base-ui'

interface CodeSampleSelectorProps {
    children?: ReactNode
    baseUi?: any
    algoliaUi?: any
    headlessUi?: any
  }

const CodeSampleSelector = ({
    baseUi,
    algoliaUi,
    headlessUi
    // children
} :CodeSampleSelectorProps ) => {
    const [serviceLineOptions] = React.useState([
        {
          label: 'Paro base-ui',
          value: 'base-ui',
        },
        {
          label: 'Algolia',
          value: 'algolia-ui',
        },
        {
          label: 'Headless UI',
          value: 'headless-ui',
        }
      ])
      const [isSelectedIndex, setisSelectedIndex] = React.useState("base-ui");
    
      const handleCodeExample = (e: any) => {
        // console.log(e.target.options.selectedIndex)
        setisSelectedIndex(e.target.value)
      }


  return (    
    <div>
        <Select
            options={serviceLineOptions}
            required={false}
            onChange={e => handleCodeExample(e)}
            className="w-6/12"
        />
        <div className="py-4">
                { isSelectedIndex === 'base-ui'  ? <Highlighter code={baseUi} language='jsx'/> : null }
                { isSelectedIndex === 'algolia-ui'  ? <Highlighter code={algoliaUi} language='jsx'/> : null  }        
                { isSelectedIndex === 'headless-ui'  ? <Highlighter code={headlessUi} language='jsx'/> : null  }        
        </div>
    </div>
  )
}

export default CodeSampleSelector
